module.exports = __webpack_public_path__ + "img/dummyprod-in-motion@1x.204a40ac.png";